import { Component } from '@angular/core';
import { ServiceBoatToWinServicesDTO } from 'src/app/models/dtos/serviceBoatToWinServicesDTO';
import { Currency } from 'src/app/models/enums/currency';
import { Tuition } from 'src/app/models/tuition';
import { BoatService } from 'src/app/services/boat.service';
import { CurrencyService } from 'src/app/services/currency.service';

@Component({
  selector: 'app-due-expire-tuitions',
  templateUrl: './due-expire-tuitions.component.html',
  styleUrls: ['./due-expire-tuitions.component.scss']
})

export class DueExpireTuitionsComponent {
  tuitions!: ServiceBoatToWinServicesDTO[];
  currentCurrency: Currency = Currency.BRL;

  constructor(
    private boatService: BoatService,
    private currencyService: CurrencyService
  ) {}

  ngOnInit(): void {
    this.currentCurrency = this.currencyService.getCurrentCurrency();

    this.boatService.getExpiringServices().subscribe((tuition) => (this.tuitions = tuition));
    console.log(this.tuitions);
  }
}
